<template>
  <v-chip label :small='!small' :xSmall='small' :color='$store.state.icons.modules.estimates.color' dark>
    <v-icon :small='!small' :xSmall='small' left>{{ $store.state.icons.modules.estimates.icon }}</v-icon>
    Estimate Generated
  </v-chip>
</template>

<script>
export default {
  name: 'wc-estimate-generated',
  props: {
    small: {
      required: false,
      type: Boolean,
      default: false
    }
  }
}
</script>
